import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthState } from '@store/auth/auth.state';
import { RouteNames } from '../../route-names';

export const isGreenlandUserGuard: CanActivateFn = () => {
  const router = inject(Router);
  const isGreenlandUser = inject(Store).selectSnapshot(
    AuthState.isGreenlandUser,
  );
  return isGreenlandUser || router.navigate([RouteNames.LOGIN_PAGE]);
};
